// extracted by mini-css-extract-plugin
export default {"wrapper":"SizeBar_wrapper__ulNdr","container":"SizeBar_container__Jdi8A","sizeButton":"SizeBar_sizeButton__IcsmO","selected":"SizeBar_selected__WYex3"};